angular.module('bmsApp.directives').controller('VisitPhotosModalCtrl', [
	'$scope',
	'$modalInstance',
	'visitType',
	'visit',
	'VisitPhotoSvc',
	'$filter',
	'$modal',
	function (
		$scope,
		$modalInstance,
		visitType,
		visit,
		VisitPhotoSvc,
		$filter,
		$modal
		) {

		$scope.loading = true;
		$scope.title = 'Visit Photos';
		if(angular.isObject(visit) && angular.isDefined(visit.job_date)){
			$scope.title = 'Visit Photos - ' + $filter('amDateFormat')(visit.job_date, 'Do MMM YYYY');
			$scope.visitDate = $filter('amDateFormat')(visit.job_date, 'Do MMM YYYY')
		} else if (angular.isObject(visit) && angular.isDefined(visit.visit_date)){
			$scope.title = 'Visit Photos - ' + $filter('amDateFormat')(visit.visit_date, 'Do MMM YYYY');
			$scope.visitDate = $filter('amDateFormat')(visit.visit_date, 'Do MMM YYYY')
		}
		VisitPhotoSvc.index({
			filter: {
				PhotoableBelongsTo: {
					visitType: visitType,
					visitId: angular.isObject(visit) ? visit.id : visit,
				},
			},
		}).then(function(response){
			$scope.photos = response.data.visit_photo_collection;
			$scope.beforePhotos = $filter('filter')($scope.photos, {'is_before':true});
			$scope.afterPhotos = $filter('filter')($scope.photos, {'is_before':false});
			$scope.loading = false;
		});

		$scope.uploadPhoto = function(is_before){
			$modalInstance.dismiss();
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/photo/templates/UploadPhotoModal.html',
				controller: 'UploadPhotoModalCtrl',
				size: 'md',
				resolve: {
					isBefore: function () {
						return is_before ? 1 : 0;
					},
					visitType: function() {
						return visitType;
					},
					visitId: function() {
						return angular.isObject(visit) ? visit.id : visit;
					}
				}
			});

			modalInstance.result.then(function (result) {
				VisitPhotoSvc.showVisitPhotosModal(visitType, visit.id);
			}, function () {
				// closed
			});
		}

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

	}]);
